// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","389":"96b2be3b","732":"fda73a07","857":"3d4c90f9","977":"01378288"}[chunkId] + ".chunk.js";
};